<template>
	<v-container fluid >
		<v-layout row wrap>
			<v-flex xs12 class="text-xs-center">
				<span class="headline">Dobro došli</span><br /><br />
				<v-icon x-large>fa-door-open</v-icon><br /><br />
				<span class="body-w">Iz izbornika odaberite neki od modula kako biste započeli s radom.</span><br /><br />
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	export default {
		name: "Dashboard",
		components: {},
		data() {
			return {
				contacts: [],
				favorites: false,
				search: ''
			}
		},
		watch: {

		},
		computed: {

		},
		methods: {

		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			} else {
				this.$router.replace('tours');
			}
		}
	}
</script>

<style scoped>
</style>
